var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(4 4)",
    fill: "#091E42",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 16.5V21C32.25 21.1989 32.171 21.3897 32.0303 21.5303C31.8897 21.671 31.6989 21.75 31.5 21.75C31.3011 21.75 31.1103 21.671 30.9697 21.5303C30.829 21.3897 30.75 21.1989 30.75 21V18.3103L26.0306 23.0306C25.8899 23.1714 25.699 23.2504 25.5 23.2504C25.301 23.2504 25.1101 23.1714 24.9694 23.0306C24.8286 22.8899 24.7496 22.699 24.7496 22.5C24.7496 22.301 24.8286 22.1101 24.9694 21.9694L29.6897 17.25H27C26.8011 17.25 26.6103 17.171 26.4697 17.0303C26.329 16.8897 26.25 16.6989 26.25 16.5C26.25 16.3011 26.329 16.1103 26.4697 15.9697C26.6103 15.829 26.8011 15.75 27 15.75H31.5C31.6989 15.75 31.8897 15.829 32.0303 15.9697C32.171 16.1103 32.25 16.3011 32.25 16.5ZM21.9694 24.9694L17.25 29.6897V27C17.25 26.8011 17.171 26.6103 17.0303 26.4697C16.8897 26.329 16.6989 26.25 16.5 26.25C16.3011 26.25 16.1103 26.329 15.9697 26.4697C15.829 26.6103 15.75 26.8011 15.75 27V31.5C15.75 31.6989 15.829 31.8897 15.9697 32.0303C16.1103 32.171 16.3011 32.25 16.5 32.25H21C21.1989 32.25 21.3897 32.171 21.5303 32.0303C21.671 31.8897 21.75 31.6989 21.75 31.5C21.75 31.3011 21.671 31.1103 21.5303 30.9697C21.3897 30.829 21.1989 30.75 21 30.75H18.3103L23.0306 26.0306C23.1714 25.8899 23.2504 25.699 23.2504 25.5C23.2504 25.301 23.1714 25.1101 23.0306 24.9694C22.8899 24.8286 22.699 24.7496 22.5 24.7496C22.301 24.7496 22.1101 24.8286 21.9694 24.9694Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.d01e36e317d3f90c1d0903061f2b42ad.svg";
export { ForwardRef as ReactComponent };